import React, { useState, useEffect } from 'react';
import SectionTitle from './SectionTitle';
import FormItemLabel from './FormItemLabel';
import Spacer from './Spacer';
import SubmitButton from './SubmitButton';
import RadioButtons from './RadioButtons';

function AfterQuestionnaire(props) {
    // State to track form values
    const [formValues, setFormValues] = useState({
        'after-question-01': '',
    });

    const [isFormComplete, setIsFormComplete] = useState(false);

    const handleChange = (name, value) => {
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    useEffect(() => {
        const allFilled = Object.values(formValues).every(value => value !== '');
        setIsFormComplete(allFilled);
    }, [formValues]);

    return (
        <div className="after-questionnaire questionnaire-form-window-container is-active">
            <div className="questionnaire-form-window">
                <SectionTitle label="最後に以下の質問にお答えください。" />
                <div className="questionnaire-form">
                    <div className="questionnaire-form-item">
                        <img className="questionnaire-form-item__image" src={`${process.env.PUBLIC_URL}/images/guide-light.svg`} alt="誘導灯" width={444} height={220} style={{maxWidth:400}} />
                        <div className="questionnaire-form-item__description">
                            <p>「これは避難口誘導灯です。火災や災害が発生した際に、建物内にいる人々が安全に避難できるように、避難口の位置や方向を明示するための照明器具です。」</p>
                        </div>
                        <FormItemLabel text="この標識の意味を知っていましたか?" required />
                        <RadioButtons
                            required
                            name="after-question-01"
                            options={["はい", "いいえ"]}
                            onChange={value => handleChange('after-question-01', value)}
                        />
                    </div>
                </div>
                <Spacer sizePC="48" />
                {!isFormComplete ?
                    <>
                        <div className="form-info">
                            <p>すべての項目を入力してください</p>
                        </div>
                        <Spacer sizePC="48" />
                    </>
                : ""}
                <SubmitButton type="submit" label="送信する" disabled={!isFormComplete} />
            </div>
        </div>
    );
}

export default AfterQuestionnaire;
